import script from "./GalleriaItemSlot.vue?vue&type=script&lang=js"
export * from "./GalleriaItemSlot.vue?vue&type=script&lang=js"

export default script